export default __webpack_public_path__ + "static/media/proj5.b565f6d6.png";